import { connect } from 'react-redux';
import { get } from 'lodash';

import Summary, {
  SummaryProps,
} from '@/components/DeprecatedPortfolio/components/Summary';
import {
  portfolioSelector,
  portfolioSummarySelector,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import { redirectToPortfolioReturnsReport } from '@/components/DeprecatedPortfolio/redux/actions';
import { ROUTE_DEPRECATED_PUBLIC_PORTFOLIO } from '@/constants/routes';
import type { LocationState } from 'redux-first-router';

const getter = (obj) => (property, defaultValue) =>
  get(obj, property, defaultValue);

type SummaryStateProps = Omit<
  SummaryProps,
  'redirectToPortfolioReturnsReport' | 'sectionNumber'
>;
const makeMapStateToProps = () => {
  const mapStateToProps = (state): SummaryStateProps => {
    const { location }: { location: LocationState } = state;
    const portfolio = portfolioSelector(state);
    const portfolioSummary = portfolioSummarySelector(state);
    const portfolioGetter = getter(portfolio);
    const summaryGetter = getter(portfolioSummary);
    return {
      isPublic: location.type === ROUTE_DEPRECATED_PUBLIC_PORTFOLIO,
      portfolioId: portfolioGetter('id', null),
      portfolioName: portfolioGetter('name', ''),
      secretCode: portfolioGetter('secretCode', ''),
      isWatchlist: summaryGetter('isWatchlist', true),
      portfolioWithNoTransactions: summaryGetter(
        'portfolioWithNoTransactions',
        false
      ),
      portfolioYearAge: summaryGetter('portfolioYearAge', 0),
      currencyISO: summaryGetter('currencyISO', 'USD'),
      annualReturn: summaryGetter('annualReturn', 0),
      snowflakeDescription: summaryGetter('snowflakeDescription', ''),
      snowflakeScoreAxes: summaryGetter('snowflakeScoreAxes', [1, 1, 1, 1, 1]),
      currentHoldingCount: portfolioGetter('currentHoldingCount', 0),
      annualReturnFormatted: summaryGetter('annualReturnFormatted', 'N/A'),
      totalDividendReturnFormatted: summaryGetter(
        'totalDividendReturnFormatted',
        'N/A'
      ),
    };
  };
  return mapStateToProps;
};

type SummaryDispatchProps = Pick<
  SummaryProps,
  'redirectToPortfolioReturnsReport'
>;
const mapDispatchToProps = (dispatch): SummaryDispatchProps => {
  return {
    redirectToPortfolioReturnsReport: (data) =>
      dispatch(redirectToPortfolioReturnsReport(data)),
  };
};

type ContainerProps = Pick<SummaryProps, 'sectionNumber'>;

export default connect<SummaryStateProps, SummaryDispatchProps, ContainerProps>(
  makeMapStateToProps,
  mapDispatchToProps
)(Summary);
